import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import CSV from "./DownloadCSV";
import lowObj from "lodash";
const CSVDownloadButton = (props) => {
  if (
    props.data &&
    Object.keys(props.data).length > 0 &&
    lowObj.has(props.data, "dob") &&
    lowObj.has(props.data, "gmail") &&
    lowObj.has(props.data, "parentsEmail1") &&
    lowObj.has(props.data, "parentsEmail2") &&
    lowObj.has(props.data, "parentsPhone1") &&
    lowObj.has(props.data, "parentsPhone2") &&
    lowObj.has(props.data, "travelTeam") &&
    lowObj.has(props.data, "classYear") &&
    lowObj.has(props.data, "sport") &&
    lowObj.has(props.data, "primaryPosition") &&
    lowObj.has(props.data, "secondaryPosition") &&
    lowObj.has(props.data, "fatherName") &&
    lowObj.has(props.data, "motherName") &&
    lowObj.has(props.data, "athletesPhone") &&
    lowObj.has(props.data, "school") &&
    lowObj.has(props.data, "advocate")
  ) {
    return (
      <CSV data={props.data}>
        <Popup
          content="Download CSV"
          trigger={
            <Button
              color="green"
              icon={<Icon name="file excel" size="large" />}
            />
          }
        />
      </CSV>
    );
  } else return null;
};

export default CSVDownloadButton;
